var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.158203,
    y: 0.09375,
    width: 21.2131,
    height: 21.2131,
    rx: 10.6066,
    fill: "#60EC2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6247 6.17821C13.6247 6.11024 13.6726 6.22627 13.6247 6.17821C13.5768 6.13014 13.6925 6.17821 13.6247 6.17821H12.2836C11.6404 6.14606 10.974 6.19451 10.4954 6.6267C10.0167 7.05889 9.63695 7.77562 9.6013 8.42069V9.76618H8.26017C8.19242 9.76618 8.30807 9.71812 8.26017 9.76618C8.21226 9.81424 8.26017 9.69821 8.26017 9.76618V11.1117C8.26017 11.1796 8.21226 11.5121 8.26017 11.5602C8.19242 11.5602 8.30807 11.6082 8.26017 11.5602H9.6013V15.1481C9.55339 15.1001 9.6013 15.2161 9.6013 15.1481C9.64921 15.1962 9.98059 15.1481 10.0483 15.1481H11.3895C11.3416 15.1962 11.4572 15.1481 11.3895 15.1481C11.4374 15.1001 11.8365 15.2161 11.8365 15.1481V11.5602H12.7306C12.7874 11.561 13.1323 11.5945 13.1777 11.5602C13.223 11.5258 13.1629 11.1667 13.1777 11.1117L13.6247 9.76618C13.6322 9.80466 13.6349 9.72831 13.6247 9.76618C13.6172 9.7277 13.6484 9.79737 13.6247 9.76618C13.601 9.73498 13.6597 9.78368 13.6247 9.76618C13.5897 9.74867 13.2167 9.7664 13.1777 9.76618H11.8365V8.42069C11.8492 8.29382 11.7421 8.05749 11.8365 7.97219C11.931 7.88689 12.1565 7.97155 12.2836 7.97219H13.6247C13.6925 7.97219 13.5768 7.57176 13.6247 7.5237C13.6247 7.59167 13.6726 7.47563 13.6247 7.5237V6.17821Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ba47b8a7197de622ce10c3c1232932c8.svg";
export { ForwardRef as ReactComponent };